import { useSyncExternalStore } from "react";

/**
 * React **하이드레이션이 끝났는가**.
 *
 * 서버 렌더와 하이드레이션 첫 렌더에는 `false`, 그 뒤 `true`. 클라이언트에만 있는 값
 * (`localStorage`·`window`)으로 분기해야 하는데 SSR 과 마크업이 갈리면 안 될 때 쓴다.
 *
 * ⚠️ **"어떤 store 가 재수화됐다"는 뜻이 아니다.** 이름 그대로 React 하이드레이션 단계만
 * 본다. 특정 store 의 준비 여부로 쓰려면 그 store 가 **동기 재수화**여야 한다
 * (zustand persist 기본값 = 동기. `skipHydration`·비동기 storage 를 켜면 성립하지 않는다).
 * 카트가 그 전제에 의존하므로 `__tests__/store/cart-store-sync-rehydration.test.ts` 가
 * 전제를 잠근다.
 *
 * ## 왜 `useState(false)` + `useEffect` 가 아닌가
 *
 * 그 방식은 `react-hooks/set-state-in-effect` 위반이고,
 * **SPA 이동에서도 한 프레임** 폴백을 그린다. `useSyncExternalStore` 는 하이드레이션
 * 에서만 서버 스냅샷을 쓰므로 필요한 곳에서만 `false` 다.
 *
 * ## 최초 도입 맥락 (#5192)
 *
 * `/cart` 는 SSR 인데 카트는 `localStorage` 에만 있다. 서버 렌더 시점엔 스토어가 비어
 * 있어 "장바구니가 비었습니다 + Continue Shopping" 이 HTML 에 박히고, 하이드레이션 후
 * 실제 항목으로 바뀌어 매 진입마다 번쩍였다(실측: SSR HTML 에 `bag is empty` 2건).
 * 문제는 느린 게 아니라 **"아직 모름"을 "비었음"이라는 확정으로 그리는 것**이었다.
 */

/** 구독 대상이 없다 — 값은 "하이드레이션 전/후" 로만 갈리고 이후 바뀌지 않는다. */
const noopSubscribe = () => () => {};

export function useHydrated(): boolean {
  return useSyncExternalStore(
    noopSubscribe,
    () => true,
    () => false,
  );
}
